<template>
  <div>
    <div class="stockli__form-intro">
      <div class="stockli__form-intro--text black-trans-bkgr">
        <div class="h4 mb-0 white-text">Stockli Indicator Setting Calculator</div>
      </div>
    </div>
    <div class="stockli__form-container">
      <div class="h2 pb-4">Hello and Welcome!</div>
      <div class="h4 pb-4">You are probably attending a Stockli event and would like to try our skis, right?</div>
      <p>Please complete the form below so that we can get skis on your feet. After completing it, we will ask you some questions and calculate your indicator setting.</p>
      <p>We would like to send you a text message and/or email so that you have a record of your setting, <span class="bold-text highlight">so please use a valid mobile phone number and email address.</span> We will also follow up with you later regarding skis and sizes you tested today.</p>
      <p><span class="bold-text highlight">We will not provide skis to you unless we have your correct information.</span></p>
      <p>We are committed to keeping your contact information confidential. We do not sell, rent, or lease our contact data or lists to third parties, and we will not provide your personal information to any third party individual, government agency, or company at any time unless compelled to do so by law.</p>
      <p>Some retailer-sponsored demo events may charge a fee, collected at the time of the demo.</p>
      <div class="progress-indicator">
        <div class="step-indicator active">Contact Info</div>
        <div class="step-line"></div>
        <div class="step-indicator">Release Preference</div>
        <div class="step-line"></div>
        <div class="step-indicator">Your Setting</div>
        <div class="step-line"></div>
        <div class="step-indicator">Submit</div>
      </div>

      <div class="pb-2 h3">Participant Information</div>
      <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="Submit">
        <v-row dense>
          <v-col cols="12" md="6">
            <v-text-field v-model="First_Name" label="Participant First Name" :rules="[ruleRequired]" />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-model="Last_Name" label="Participant Last Name" :rules="[ruleRequired]" />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="6">
            <v-text-field v-model="Email" type="email" label="Participant Email" :rules="[ruleRequired, ruleEmail]" />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field v-mask="'+1 (###) ###-####'" v-model="Mobile" type="tel" label="Participant Mobile Phone" :rules="[ruleRequired, rulePhone]" />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-text-field v-model="Street" label="Participant Address" :rules="[ruleRequired]" />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="6">
            <v-text-field v-model="City" label="Participant City" :rules="[ruleRequired]" />
          </v-col>
          <v-col cols="12" md="6">
            <v-select v-model="State" label="Participant State / Province" :items="enumStates" :rules="[ruleRequired]" />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="6">
            <v-text-field v-model="Zip_Code" label="Participant Zip Code" maxlength="6" :rules="[ruleRequired]" />
          </v-col>
          <v-col cols="12" md="6">
            <v-select v-model="Country" label="Participant Country" :items="['USA', 'Canada']" :rules="[ruleRequired]" />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-text-field label="Age" v-model="Age" type="number" :rules="[ruleRequired]" />
          </v-col>
        </v-row>

        <!-- Parent / Guardian stuff -->
        <v-row dense>
          <v-col cols="12">
            <v-checkbox v-model="Has_Guardian" label="Are you a parent or guardian of a participant who is under 18?" :rules="[ruleParent]" />
          </v-col>
        </v-row>
        <div v-if="Has_Guardian">
          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field v-model="Guardian_First_Name" label="Parent or Guardian First Name" :rules="[ruleRequired]" />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="Guardian_Last_Name" label="Parent or Guardian Last Name" :rules="[ruleRequired]" />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-checkbox v-model="Copy_Guardian" label="Use participant contact info" />
            </v-col>
          </v-row>
          <div v-if="!Copy_Guardian">
            <v-row dense>
              <v-col cols="12" md="6">
                <v-text-field v-model="Guardian_Email" type="email" label="Parent or Guardian Email" :rules="[ruleRequired, ruleEmail]" />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-mask="'+1 (###) ###-####'" v-model="Guardian_Phone" type="tel" label="Parent or Guardian Mobile Phone" :rules="[ruleRequired, rulePhone]" />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-text-field v-model="Guardian_Street" label="Parent or Guardian Address" :rules="[ruleRequired]" />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" md="6">
                <v-text-field v-model="Guardian_City" label="Parent or Guardian City" :rules="[ruleRequired]" />
              </v-col>
              <v-col cols="12" md="6">
                <v-select v-model="Guardian_State" label="Parent or Guardian State / Province" :items="enumStates" :rules="[ruleRequired]" />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" md="6">
                <v-text-field v-model="Guardian_Zip_Code" label="Parent or Guardian Zip Code" maxlength="6" :rules="[ruleRequired]" />
              </v-col>
              <v-col cols="12" md="6">
                <v-select v-model="Guardian_Country" label="Parent or Guardian Country" :items="['USA', 'Canada']" :rules="[ruleRequired]" />
              </v-col>
            </v-row>
          </div>
        </div>
        <v-row dense class="mt-5">
          <v-col cols="4" sm="3">
            <v-btn type="submit">Continue</v-btn>
          </v-col>
          <v-col>
            <div v-if="!valid" class="validation-error-message">Please correct the errors above before submitting.</div>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  name: "ParticipantInfo",
  data: () => ({
    skiBrands: [
      "Atomic",
      "Black Crows",
      "Blizzard",
      "DPS Skis",
      "Head",
      "K2 Sports",
      "Line",
      "Nordica",
      "Rossignol",
      "Salomon",
      "Stockli",
      "Völkl",
      "Other",
    ],

    skiAges: [
      "0-2 years",
      "3-4 years",
      "5-6 years",
      "7-8 years",
      "9 or more years",
    ],
    enumStates: ["Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "District of Columbia", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming", "Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador", "Northwest Territories", "Nova Scotia", "Nunavut", "Ontario", "Prince Edward Island", "Quebec", "Saskatchewan", "Yukon Territory"],

    valid: undefined,
    ruleRequired: v => !!v || "This field is required",
    ruleEmail: v => /.+@.+\..+/.test(v) || "Valid email required",
    rulePhone: v => (v && v.length === 17) || "Valid mobile number required",
  }),
  computed: {
    // Vuex is convoluted to alter values. This plugin simplifies direct binding to object properties in the store.
    ...mapFields([
      "skierInfo.Current_Ski_Brand",
      "skierInfo.Current_Ski_Age",
      "skierInfo.First_Name",
      "skierInfo.Last_Name",
      "skierInfo.Email",
      "skierInfo.Mobile",
      "skierInfo.Street",
      "skierInfo.City",
      "skierInfo.State",
      "skierInfo.Zip_Code",
      "skierInfo.Country",
      "skierInfo.Age",

      "skierInfo.Has_Guardian",

      "skierInfo.Guardian_First_Name",
      "skierInfo.Guardian_Last_Name",

      "skierInfo.Copy_Guardian",

      "skierInfo.Guardian_Email",
      "skierInfo.Guardian_Phone",
      "skierInfo.Guardian_Street",
      "skierInfo.Guardian_City",
      "skierInfo.Guardian_State",
      "skierInfo.Guardian_Zip_Code",
      "skierInfo.Guardian_Country",

      "skierInfo.Participant_Tag",
    ]),
    skierInfo() {
      return this.$store.state.skierInfo;
    },
    ruleParent() {
      return v => (!!v || this.Age >= 18) || "For participants under 18, a parent or guardian must fill out the form";
    },
  },
  async mounted() {
    if (this.$route.query.tag) {
      window.sessionStorage.setItem("Participant_Tag", this.$route.query.tag);
      this.$emit("tag-set");
    }
  },
  methods: {
    async Submit() {
      if (!this.$refs.form.validate()) return;

      // Copy the guardian info if the user wants it
      if (this.Copy_Guardian) {
        this.Guardian_Email = this.Email;
        this.Guardian_Phone = this.Mobile;
        this.Guardian_Street = this.Street;
        this.Guardian_City = this.City;
        this.Guardian_State = this.State;
        this.Guardian_Zip_Code = this.Zip_Code;
        this.Guardian_Country = this.Country;
      }

      // If we have a tag for this session, apply it
      const tag = window.sessionStorage.getItem("Participant_Tag");
      this.Participant_Tag = tag;

      this.$router.push({ name: "Calculator" });
    },
  },
  watch: {
    Has_Guardian() {
      // Turn off Agree if they change guardian status
      this.Agree = false;
    },
  },
}
</script>
<style scoped lang="scss"></style>
